import { Box, Container, Grid, Typography } from "@mui/material";
import PropTypes from "prop-types";
import "../StatusScreenMs/StatusScreenMs.css";
import "./SetPasswordInstructions.css";
import { useTenant } from "../../contexts/TenantService";
import { useLocation } from "react-router-dom";
import { CredentialMgmtDataService } from "../../services/CredentialMgmtDataService";
import MsShimmer from "../MsShimmer/MsShimmer";
import { useState } from "react";
import StatusScreenMs from "../StatusScreenMs/StatusScreenMs";
function SetPasswordInstructions({ onResend, navigationUrl, showBackToLoginAvl, showResendAvl }) {
  const location = useLocation();
  const { tenantSvc } = useTenant();
  const params = new URLSearchParams(location.search);
  const loginHint = params.get("login_hint") || "";

  const loginUrl = showBackToLoginAvl ? navigationUrl : `${tenantSvc?.authExitUrl}?login_hint=${loginHint}`;
  const [resendStatus, setResendStatus] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setIsLoading] = useState(false);
  const credentialService = CredentialMgmtDataService();

  const onResendFallBack = () => {
    setIsLoading(true);
    credentialService
      .forgotPassword("/accounts/operations/forgot-password", { email: loginHint })
      .then((response) => {
        setIsLoading(false);
        setResendStatus(response.status);
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error?.response?.data?.error);
        setResendStatus(error.response.status);
      });
  };
  if (loading) {
    return <MsShimmer />;
  }
  if (resendStatus === 400 || resendStatus === 500) {
    return <StatusScreenMs status={error} />;
  }
  return (
    <Grid className="ms-set-password-instruction-container">
      <div className="ms-wl-bank-logo" data-testid="svg-icon">
        <img src="/ciam/v1/static/images/ms/Worldline-Mint-Horizontal.svg" alt="Worldline" />
      </div>
      <Grid item xs={7} className="right-gradient" data-testid="right-gradient-circle">
        <img src="/ciam/v1/static/images/ms/right-circle.svg" alt="right-circular-gradient" />
      </Grid>
      <div className="ms-set-password-left">
        <Container className="ms-form-container">
          <Box className="ms-box-container">
            <Typography variant="h5" fontWeight={600} alignSelf="center" className="mail-icon">
              <img src="/ciam/v1/static/images/ms/Group.svg" alt="mail" />
            </Typography>
            <Typography variant="h5" fontWeight={600} className="head-mail">
              We sent you an email with further instructions
            </Typography>
            <Typography variant="body1" className="instructions-mail">
              Follow the steps described in the email to set a new password.
            </Typography>
            <Typography variant="body1" className="instructions-mail">
              Did you not receive an email? Check your Spam folder or&nbsp;
              <span className="send-again" onClick={showResendAvl ? onResend : onResendFallBack}>
                send again
              </span>
              .
            </Typography>
            <Typography variant="body1" className="back-to-login" onClick={() => (window.location.href = loginUrl)}>
              Back to login
            </Typography>
          </Box>
        </Container>
      </div>
    </Grid>
  );
}

export default SetPasswordInstructions;
SetPasswordInstructions.propTypes = {
  onResend: PropTypes.func,
  navigationUrl: PropTypes.string,
  showBackToLoginAvl: PropTypes.bool,
  showResendAvl: PropTypes.bool,
};

SetPasswordInstructions.defaultProps = {
  showBackToLoginAvl: false,
  showResendAvl: false,
};
